import { WhatsappLogo } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

export default function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <a
      href="https://api.whatsapp.com/send?phone=393759730405"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t.contact.whatsappCta}
      title={t.contact.whatsappCta}
      className="fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full border border-champagne/60 bg-navy text-champagne shadow-xl shadow-navy/30 transition-transform duration-300 hover:scale-110"
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
}
